import React, {useState, useEffect} from 'react';
import './Reportes.css';
import api from '../../../services/api';
import swal from 'sweetalert';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash, faClipboard } from '@fortawesome/free-solid-svg-icons'
import studentImage from '../../../images/student_portrait.svg'
import SearchableSelect from "../../Generales/SearchableSelect/SearchableSelect";

const Reportes = () => {
    const [tipoReporte, setTipoReporte] = useState([]);
    const [personalReporte, setPersonalReporte] = useState([]);

    const [showMessage, setShowMessage] = useState(false);

    const [showInfo, setShowInfo] = useState(false);
    const [infoAlumno, setInfoAlumno] = useState([]);
    const [alumnoSeleccionadoFocus, setAlumnoSeleccionadoFocus] = useState([]);
    const [fotoAlumno, setFotoAlumno] = useState();

    const [showSearch, setShowSearch] = useState(false);
    const [listaAlumnos, setListaAlumnos] = useState([]);
    const [alumno, setAlumno] = useState([]);
    
    const [alumnos, setAlumnos] = useState([]);
    const [alumnosSeleccionados, setAlumnosSeleccionados] = useState([]);
    const [turno, setTutno] = useState(1);
    const [grado, setGrado] = useState(1);
    const [grupo, setGrupo] = useState(null);

    const [nivelGravedad, setNivelGravedad] = useState('');
    const [tipoSuspension, setTipoSuspension] = useState('');
    const [motivosReporte, setMotivosReportes] = useState([]);
    const [descripcionReporte, setDescripcionReporte] = useState('');
    const [personaReporta, setPersonaReporta] = useState('');

    const buttonDisable = {
        cursor: "not-allowed",
        opacity: "0.5",
        pointerEvents: "none",
    }

    useEffect(() => {

        const fetchData = async () => {
            try {
                const response = await api.getTipoReporte();
                setTipoReporte(response.data.data);
                const responsePersonal = await api.getPersonalReporte();
                setPersonalReporte(responsePersonal.data.data);
            } catch (error) {
                
            }
        };

        const fotoAlumno = async () => {
            try {
                const MATRICULA = alumnosSeleccionados[0].MATRICULA;
                const response = await api.getFotoAlumno({MATRICULA});
                const FOTO = response.data.data.FOTO;

                const arrayBuffer = new Uint8Array(FOTO.data);
                const base64String = btoa(
                  arrayBuffer.reduce((data, byte) => data + String.fromCharCode(byte), '')
                );
                setFotoAlumno(`data:image/jpeg;base64,${base64String}`);
            } catch (error) {
                setFotoAlumno(studentImage);

            }
        };

        try {
            setAlumnoSeleccionadoFocus(alumnosSeleccionados[0]);
            fotoAlumno();
        } catch (error) {
        }

        fetchData();
    }, [alumnosSeleccionados]);

    const buscar1Alumno = async () => {
        setShowSearch(true);    
        try {
            const response = await api.getAlumnosAsistencias({alumno});
            setListaAlumnos(response.data.data);
        } catch (error) {
            swal("Error", "Intente de nuevo más tarde.", "error");
        }
    }

    const buscarAlumnos = async () => {
        try {
            const response = await api.getAlumnosList({turno, grado, grupo});
            setAlumnos(response.data.data);
        } catch (error) {
            swal("Error", "Intente de nuevo más tarde.", "error");
        }
    }

    const registrarReporte = async () => {
        try {
            const ID_PERSONAL_REPORTA = personaReporta.ID_PERSONAL;
            const response =await api.postRegistrarReporte({nivelGravedad, tipoSuspension, motivosReporte, descripcionReporte, alumnosSeleccionados, ID_PERSONAL_REPORTA});
            if (response.data.success) {
                swal("¡Éxito!", "Los reportes se registraron correctamente.", "success");
            }
            else{
                swal("Error", "Intente de nuevo más tarde.", "error");
            }
        } catch (error) {
            swal("Error", "Intente de nuevo más tarde.", "error");
        }
    }

    async function verInfoAlumno(alumno) {
        const MATRICULA = alumno.MATRICULA;
        try {
            setShowInfo(true);
            const response = await api.getInfoAlumnoCompleta({MATRICULA})
            setInfoAlumno(response.data.data);
            
        } catch (error) {
            swal("Error", "Intente de nuevo más tarde.", "error");
        }

        try {
            
            const response = await api.getFotoAlumno({MATRICULA});
            const FOTO = response.data.data.FOTO;

            const arrayBuffer = new Uint8Array(FOTO.data);
            const base64String = btoa(
              arrayBuffer.reduce((data, byte) => data + String.fromCharCode(byte), '')
            );
            setFotoAlumno(`data:image/jpeg;base64,${base64String}`);
            
        } catch (error) {
            setFotoAlumno(studentImage);
        }
    }

    async function agregarAlumno(alumno) {
        setAlumnosSeleccionados((prevAlumnos) => [...prevAlumnos, alumno]);
        setAlumnos((prevAlumnos) => prevAlumnos.filter((a) => a.MATRICULA !== alumno.MATRICULA));
        setShowSearch(false);
    }

    async function eliminarAlumno(alumno) {
        setAlumnos((prevAlumnos) => [...prevAlumnos, alumno]);
        setAlumnosSeleccionados((prevAlumnos) => prevAlumnos.filter((a) => a.MATRICULA !== alumno.MATRICULA));
    }

    async function handleSeleccionarAlumnoFocus(matricula) {
        const alum = alumnosSeleccionados.find(alumno => alumno.MATRICULA === matricula);
        setAlumnoSeleccionadoFocus(alum);

        try {
            const response = await api.getFotoAlumno({MATRICULA: matricula});
            const FOTO = response.data.data.FOTO;

            const arrayBuffer = new Uint8Array(FOTO.data);
            const base64String = btoa(
              arrayBuffer.reduce((data, byte) => data + String.fromCharCode(byte), '')
            );
            setFotoAlumno(`data:image/jpeg;base64,${base64String}`);
            
        } catch (error) {
            setFotoAlumno(studentImage);
        }
    }

    const handleCheckboxChange = (event) => {
        const { value, checked } = event.target;
    
        setMotivosReportes((prev) =>
          checked
            ? [...prev, value]
            : prev.filter((id) => id !== value)
        );
    };

    return (
        <>
        <div className= "seccion-materias hover-seccion fade-in">
            <div className= "seccion-centro">
                <div className='container-filtros'>
                    <div className='container-filtros-tabla'>
                        <div className='filtros-input'>
                            <label>Turno</label>
                            <select name="Turno" onChange={e => (setTutno(e.target.value))}>
                                <option value="1" defaultChecked>MATUTINO</option>
                                <option value="2">VESPERTINO</option>
                            </select>
                        </div>
                        <div className='filtros-input'>
                            <label>Grado</label>
                            <select name="Grado" onChange={e => (setGrado(e.target.value))}>
                                <option value="1" defaultChecked>PRIMERO</option>
                                <option value="2">SEGUNDO</option>
                                <option value="3">TERCERO</option>
                            </select>
                        </div>
                        <div className='filtros-input'>
                            <label>Grupo</label>
                            <input type="number" onChange={ e => (setGrupo(e.target.value))}></input>
                        </div>
                        <div className='asistencia-buscar'>
                            <label htmlFor='student-name'>Nombre del Alumno:</label>
                            <input type='text' name='student-name' value={alumno} onChange={e => {setAlumno(e.target.value)}}
                                style={{fontSize: '20px', height: '20px'}}></input>
                        </div>
                    </div>
                    <div className='buscar-envio-mensaje'>
                        <button onClick={buscarAlumnos}>BUSCAR</button>
                        <button onClick={buscar1Alumno} className='button-buscar-alumno'>BUSCAR ALUMNO</button>
                    </div>
                    <div className='button-enviar-mensaje'>
                        <button onClick={e => setShowMessage(true)} style={alumnosSeleccionados.length > 0 ? {} : buttonDisable}>HACER REPORTE</button>
                    </div>
                </div>
                <div className= "seccion-tabla-asistencias">
                    <div className= "hover-elemento">
                        {/* TABLA */}
                        <div className= "contenedor-tabla-mensajes">
                            <table className= "tabla-mensajes lista-mensajes">
                                <thead>
                                    <tr>
                                        <th><label>MATRICULA</label></th>
                                        <th><label>ALUMNO</label></th>
                                    </tr>
                                </thead>
                                <tbody className='select-pointer'>
                                    { alumnos && alumnos.map( (alumno, i) => { 
                                        return (
                                        <tr key={ i } onClick={e => agregarAlumno(alumno)}>
                                            <td>{ alumno.MATRICULA }</td>
                                            <td>{ alumno.NOMBRE }</td>
                                        </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                            <table className= "tabla-mensajes alumnos-seleccionados">
                                <thead>
                                    <tr>
                                        <th><label>MATRICULA</label></th>
                                        <th><label>ALUMNO</label></th>
                                        <th><label>INFO</label></th>
                                        <th><label>ELIMINAR</label></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    { alumnosSeleccionados && alumnosSeleccionados.map( (alumno, i) => { 
                                        return (
                                        <tr key={ i }>
                                            <td>{ alumno.MATRICULA }</td>
                                            <td>{ alumno.NOMBRE }</td>
                                            <td><label className='select-pointer-Info' onClick={e => verInfoAlumno(alumno)}><FontAwesomeIcon icon={faClipboard} /></label></td>
                                            <td><label className='select-pointer-X' onClick={e => eliminarAlumno(alumno)} ><FontAwesomeIcon icon={faTrash} /></label></td>
                                        </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        { showSearch ? <>
            <div className="overlay"></div>
            <div className='container-buscar-alumno'>
                <div className='title-buscar-alumno'>
                    <h3>SELECCIONA AL ALUMNO</h3>
                    <label className='button-close-buscar-alumno' onClick={e => setShowSearch(false)}> X </label>
                </div>
                <div className='container-table-buscar-alumno'>
                    <table className='table-buscar-alumno'>
                        <thead>
                            <tr>
                                <th><label>MATRICULA</label></th>
                                <th><label>ALUMNO</label></th>
                                <th><label>TURNO</label></th>
                                <th><label>GRADO</label></th>
                                <th><label>GRUPO</label></th>
                            </tr>
                        </thead>
                        <tbody>
                            { listaAlumnos && listaAlumnos.map( (alumno, i) => { 
                                return (
                                <tr key={ i } onClick={e => agregarAlumno(alumno)}>
                                    <td>{ alumno.MATRICULA }</td>
                                    <td>{ alumno.ALUMNO }</td>
                                    <td>{ alumno.NIVEL }</td>
                                    <td>{ alumno.ID_GRADO }</td>
                                    <td>{ alumno.GRUPO }</td>
                                </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
        </> : ''}
        { showMessage ? <>
            <div className='overlay'></div>
            <div className='container-reporte'>
                <div className='titulo-reporte'>
                    <h3>GENERA EL REPORTE</h3>
                    <label className='button-close-buscar-alumno' onClick={e => setShowMessage(false)}> X </label>
                </div>
                <div className='container-img-reporte'>
                    <div className='data'>
                        <div className='container-data-reporte'>
                            <div className="data-group-nombre">
                                <label>Nombre del Alumno</label>
                                <p>{alumnoSeleccionadoFocus.NOMBRE}</p>
                                <p className='turno'>MATUTINO</p>
                            </div>
                        </div>
                        <div className='container-data-reporte-nombre'>
                            <div className="data-group-alumnos">
                                <label>Alumnos:</label>
                                <select id="reporte-alumno" name="reporte-alumno" value={alumnoSeleccionadoFocus.MATRICULA} onChange={e => handleSeleccionarAlumnoFocus(e.target.value)}>
                                    { alumnosSeleccionados && alumnosSeleccionados.map( (alumno, i) => {
                                        return (
                                            <option value={alumno.MATRICULA} key={i}>{alumno.NOMBRE}</option>
                                        )
                                    })}
                                </select>
                            </div>
                        </div>
                    </div>
                    <img src={fotoAlumno} alt="foto-alumno-reporte" />
                </div>
                <div className='container-registrar-reporte'>
                    <h4>Descripción de la Falta</h4>
                    <div className='container-radio-input'>
                        <div className="radio-container">
                            <p>Nivel de Gravedad</p>
                            <label>
                                <input type="radio" name="nivelGravedad" value="1" onChange={e => setNivelGravedad(e.target.value)}/>
                                Normal
                            </label>
                            <label>
                                <input type="radio" name="nivelGravedad" value="2" onChange={e => setNivelGravedad(e.target.value)}/>
                                Grave o de Cuidado
                            </label>
                        </div>
                        <div className="radio-container input-3">
                            <p>Tipo de Suspensión</p>
                            <label>
                                <input type="radio" name="tipoSuspension" value="0" onChange={e => setTipoSuspension(e.target.value)}/>
                                Ninguno
                            </label>
                            <label>
                                <input type="radio" name="tipoSuspension" value="1" onChange={e => setTipoSuspension(e.target.value)}/>
                                Aviso de Suspensión si Reincide
                            </label>
                            <label>
                                <input type="radio" name="tipoSuspension" value="2" onChange={e => setTipoSuspension(e.target.value)}/>
                                Suspensión por Reincidencia
                            </label>
                        </div>
                    </div>
                </div>
                <div className='container-motivo-reporte'>
                    <div className='container-tipos-reporte'>
                        <h4>Seleccione el o los Motivos del Reporte al Alumno</h4>
                        <div className='tipos-reporte'>
                            { tipoReporte && tipoReporte.map( (tipo, i) => { 
                                return (
                                    <label key={i}>
                                        <input type="checkbox" name={tipo.ID_TIPO} value={tipo.ID_TIPO} onChange={handleCheckboxChange}/>
                                        {tipo.TIPO_REPORTE}
                                    </label>
                                );
                            })}
                        </div>
                    </div>
                    <div className='container-descripcion-reporte'>
                        <h4>Descripción de los Hechos</h4>
                        <textarea value={descripcionReporte} onChange={e => setDescripcionReporte(e.target.value)}></textarea>
                    </div>
                </div>
                <div className='container-buttons-reporte'>
                    <div className='select-quien-reporta'>
                        <SearchableSelect
                            options={personalReporte}
                            onChange={setPersonaReporta}
                            placeholder="Busca la persona que reporta"
                        />
                        <label>QUIEN REPORTA</label>
                    </div>
                    <div className='button-enviar-mensaje'>
                        <button onClick={registrarReporte}>REPORTAR</button>
                    </div>
                </div>
            </div>
        </> : ''}
        { showInfo ? <>
            <div className='overlay'></div>
            <div className='container-info-reporte'>
                <div className='titulo-message'>
                    <h3>INFORMACIÓN DEL ALUMNO</h3>
                    <label className='button-close-buscar-alumno' onClick={e => setShowInfo(false)}> X </label>
                </div>
                <hr></hr>
                <div className='container-data-reporte'>
                    <div className="data-alumno-reporte">
                        <div className='data-info-alumno-reporte-img'>
                            <img src={fotoAlumno} alt="foto-alumno-reporte" />
                        </div>
                        <label>Matricula: <p>{infoAlumno.MATRICULA}</p></label>
                        <label>Nombre: <p>{infoAlumno.NOMBRE}</p></label>
                        <label>Turno: <p>{infoAlumno.NIVEL}</p></label>
                        <label>Grado y Grupo: <p>{infoAlumno.ID_GRADO + " " + infoAlumno.GRUPO}</p></label>
                    </div>
                    <div className="container-info-alumno-reporte">
                        <div className="data-info-alumno-reporte">
                            <h3>Datos del Padre</h3>
                            <label>Nombre: <p>{infoAlumno.NOMBRE_PADRE}</p></label>
                            <label>Profesión: <p>{infoAlumno.PROFESION_PADRE}</p></label>
                            <label>Trabajo: <p>{infoAlumno.TRABAJO_PADRE}</p></label>
                            <label>Teléfono: <p>{infoAlumno.TELEFONO_PADRE}</p></label>
                        </div>
                        <div className="data-info-alumno-reporte">
                            <h3>Datos de la Madre</h3>
                            <label>Nombre: <p>{infoAlumno.NOMBRE_MADRE}</p></label>
                            <label>Profesión: <p>{infoAlumno.PROFESION_MADRE}</p></label>
                            <label>Trabajo: <p>{infoAlumno.TRABAJO_MADRE}</p></label>
                            <label>Teléfono: <p>{infoAlumno.TELEFONO_MADRE}</p></label>
                        </div>
                        <div className="data-info-alumno-reporte">
                            <h3>Domicilio Familiar</h3>
                            <label>Calle y Número: <p>{infoAlumno.DOMICILIO}</p></label>
                            <label>Colonia y CP: <p>{infoAlumno.COLONIA + " " + infoAlumno.CP}</p></label>
                            <label>Localidad: <p>{infoAlumno.LOCALIDAD}</p></label>
                            <label>Teléfono Casa: <p>{infoAlumno.TELEFONO_CASA}</p></label>
                        </div>
                    </div>
                </div>
            </div>
        </> : ''}
        </>
    );
};

export default Reportes;